import React, { useEffect } from 'react';
import 'bootstrap';
import 'aos'
import '../assets/css/style.css';
import '../assets/vendor/animate.css/animate.min.css';
import '../assets/vendor/aos/aos.css';
import '../assets/vendor/bootstrap/css/bootstrap.min.css';
import '../assets/vendor/bootstrap-icons/bootstrap-icons.css';
import '../assets/vendor/boxicons/css/boxicons.min.css';
import '../assets/vendor/glightbox/css/glightbox.min.css';
import '../assets/vendor/remixicon/remixicon.css';
import '../assets/vendor/swiper/swiper-bundle.min.css';
import { Link as RouterLink } from 'react-router-dom';
import labill1 from './../assets/img/Illustrations/Laboratory-amico.svg';
import fastDep from './../assets/img/Illustrations/Setup-amico.svg';
import dots from './../assets/img/Illustrations/Dots.png';
import tlims_main from './../assets/img/Illustrations/tlims_main.png';
import tlims_sub_1 from './../assets/img/Illustrations/tlims_sub_1.png';
import tlims_sub_2 from './../assets/img/Illustrations/tlims_sub_2.png';
import DownloadBrochure from './DownloadBrochure';
import Faq from './Faq';


const TLims = () => {

    useEffect(() => {
        window.scrollTo(0, 0); 
    }, []);

    
    return (<div className='portifoliobody' id="LIMS">
        <main id="main">
            <section className="about text-start" style={{paddingTop:'60px'}}>
                <div className='landing-page'>
                    <div>
                        <div className="landing-title carousel-container animate__animated animate__fadeInLeft" data-aos="fade-left" data-aos-delay="100">
                            <h1>Lab Iconics T-LIMS, The Complete Testing Laboratory Management System for Accuracy, Compliance, and Operational Excellence</h1>
                            <div style={{width:'82%'}}>
                                <p>
                                Streamlines sample management, ensures regulatory compliance, centralizes testing data, and accelerates reporting with secure, cloud-based accessibility.
                                </p>
                            </div>
                            <div className="book_a_demo product-demo" style={{padding:'1rem 1rem 0 0'}}>
                                <RouterLink to='/demo'> 
                                    <button className="book_a_demo_btn product-demo-btn">Get a Demo</button>
                                </RouterLink>
                            </div>
                        </div>
                        {/* <div className="left-img">
                            <img src={dots} alt="" />
                        </div> */}
                        <div className="landing-img-div landing-img-div-tlims carousel-container col-12 col-lg-6 animate__animated animate__fadeInRight" data-aos="fade-right" data-aos-delay="100">
                            <img src={tlims_sub_1} alt="" />
                        </div>
                    </div>
                </div>

                <div className="section-container" style={{margin:'0px'}}>
                    <div className="row">
                        <div className="section-pro">
                            <div className="sec-out">
                                <div className="sec-pro-img" data-aos="fade-up" data-aos-delay="100">
                                    <img src={tlims_main} alt=""/>
                                </div>  
                                <div className="sec-pro-desc" data-aos="fade-up" data-aos-delay="100">
                                    <div className="sec-title"><h1>Revolutionizing Lab Management with Lab Iconics</h1></div>
                                    <ul>
                                        <li><b>Complete Sample Lifecycle Management – </b>Lab Iconics Testing Management streamlines the entire sample journey — from registration to disposal — ensuring traceability, speed, and reduced manual errors.</li>
                                        <li><b> Assured Regulatory Compliance – </b> Designed to meet the requirements of pharma (FDA, WHO-GMP) and food testing standards (FSSAI, ISO 17025, NABL), Lab Iconics Testing Management simplifies audit preparation and compliance.</li>
                                        <li><b>Centralized Data Repository – </b> All test methods, results, approvals, and documents are managed centrally through Lab Iconics Testing Management, enhancing data integrity and easy retrieval.</li>
                                        <li><b>Automated Workflows and Task Scheduling – </b> Lab Iconics Testing Management automates sample assignment, test scheduling, analyst task tracking, and approvals, improving operational efficiency and consistency.</li>
                                        <li><b>Fast and Accurate Certificate of Analysis (CoA) Generation – </b>Generate fully compliant, customizable CoAs quickly with Lab Iconics Testing Management, including electronic signature support for authenticity and speed.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div className="section-pro">
                            <div className="sec-out">
                                <div className="sec-pro-desc" data-aos="fade-up" data-aos-delay="100">
                                    <div className="sec-title-2"><h1>Enhancing Research & Innovation with Lab Iconics</h1></div>
                                    <ul className='sec-ul'>
                                        <li style={{hyphens:'auto'}}><b>Quality Monitoring and CAPA Management –</b> Lab Iconics Testing Management tracks quality trends, highlights deviations, and supports proactive Corrective and Preventive Action (CAPA) processes to maintain high standards.</li>
                                        <li style={{hyphens:'auto'}}><b>Comprehensive Audit Trails and E-Signatures –  </b>Every action is tracked with detailed audit trails and secure electronic signatures within Lab Iconics Testing Management, ensuring accountability and regulatory compliance (21 CFR Part 11).</li>
                                        <li style={{hyphens:'auto'}}><b>Inventory, Equipment, and Resource Management – </b>  Manage lab consumables, reagents, and equipment maintenance seamlessly through Lab Iconics Testing Management to avoid shortages and ensure calibration compliance.</li>
                                        <li style={{hyphens:'auto'}}><b>Real-Time Analytics and Reporting Dashboards – </b> Lab Iconics Testing Management provides dynamic dashboards, real-time KPI tracking, and automated reporting for data-driven decision-making.</li>
                                        <li style={{hyphens:'auto'}}><b>Cloud-Based, Secure, and Scalable – </b> Access Lab Iconics Testing Management from anywhere securely with role-based access controls, enabling multi-location lab management and future scalability.</li>
                                    </ul>
                                </div>
                                <div className="sec-pro-img" data-aos="fade-up" data-aos-delay="100">
                                    <img src={tlims_sub_2} alt="" style={{width:'100%'}}/>
                                </div>  
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
        <div className="down-broch" data-aos="fade-up">
            <DownloadBrochure product={'T-LIMS'}/>
        </div>
        <div data-aos="fade-up">
            <Faq product={'T-LIMS'}/>
        </div>
    </div>

    );
};

export default TLims;
